import { PanelLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui/button';
import { useSidebarStore } from '~/lib/store/sidebar';
import { TopBarLeftZone } from './top-bar-left-zone';
import { Breadcrumbs } from './breadcrumbs';
import { SearchTrigger } from './search-trigger';
import { SiteContextMenu } from './site-context-menu';
import { LanguageMenu } from './language-menu';
import { NotificationsBell } from './notifications-bell';
import { ThemeToggle } from './theme-toggle';
import { UserMenu } from './user-menu';

function Divider() {
	return <span className="h-[18px] w-px bg-border" />;
}

/**
 * Topbar (48px). Left zone sits over the sidebar column; the right zone holds the
 * navigation context (hamburger + breadcrumbs) on the start and the utilities
 * (search, site, language, notifications, theme, user) on the end.
 */
export function TopBar() {
	const { t } = useTranslation();
	const toggleCollapsed = useSidebarStore(s => s.toggleCollapsed);
	return (
		<div className="flex h-12 w-full border-b border-border bg-surface">
			<div className="w-[var(--sidebar-width)] shrink-0 transition-[width] duration-200 ease-out">
				<TopBarLeftZone />
			</div>
			<div className="flex flex-1 items-center justify-between gap-1 px-3">
				<div className="flex min-w-0 items-center gap-2">
					<Button variant="ghost" size="icon-sm" onClick={toggleCollapsed} aria-label={t('shell.toggleSidebar')}>
						<PanelLeft size={16} />
					</Button>
					<Breadcrumbs />
				</div>
				<div className="flex items-center gap-1">
					<SearchTrigger />
					<Divider />
					<SiteContextMenu />
					<LanguageMenu />
					<NotificationsBell />
					<ThemeToggle />
					<Divider />
					<UserMenu />
				</div>
			</div>
		</div>
	);
}
